(function() {
  var QUERY_FIELD_PREFIX = /^(tag|title|body|vendor|product_type|variants\.sku):/i;
  var ALIAS_TO_CATEGORY_TAG = {
    '釣り': '35.フィッシング',
    '魚釣り': '35.フィッシング',
    'アウトドアスポーツ': '4.アウトドア・スポーツ',
    '車': '3.車・バイク'
  };

  function normalize(value) {
    return String(value || '')
      .replace(/\u3000/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normalizeLookup(value) {
    return normalize(value)
      .replace(/[・･]/g, '')
      .replace(/[／/]/g, '')
      .replace(/\s+/g, '');
  }

  function categoryData() {
    return Array.isArray(window.petaCollectionCategoryData) ? window.petaCollectionCategoryData : [];
  }

  function categoryTagForKeyword(keyword) {
    var normalized = normalize(keyword);
    if (!normalized) return '';
    var aliasTag = ALIAS_TO_CATEGORY_TAG[normalized] || ALIAS_TO_CATEGORY_TAG[normalizeLookup(normalized)];
    if (aliasTag) return aliasTag;

    var lookup = normalizeLookup(normalized);
    var exactMatches = [];
    var pathMatches = [];

    categoryData().forEach(function(category) {
      if (normalizeLookup(category.title) === lookup) exactMatches.push(category);
      if (normalizeLookup(category.path) === lookup) pathMatches.push(category);
    });

    if (pathMatches.length === 1) return pathMatches[0].tag;
    if (exactMatches.length === 1) return exactMatches[0].tag;
    return '';
  }

  function searchFieldValue(value) {
    var normalized = normalize(value);
    if (/[\s"]/g.test(normalized)) {
      return '"' + normalized.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
    }
    return normalized;
  }

  function isSingleKanaKeyword(value) {
    var lookup = normalizeLookup(value);
    return lookup.length === 1 && /[\u3041-\u3096\u30a1-\u30fa]/.test(lookup);
  }

  function unquoteFieldValue(value) {
    return normalize(value).replace(/^"|"$/g, '');
  }

  function fieldValues(rawQuery, fieldName) {
    var values = [];
    var regex = new RegExp('(?:^|[\\s(])' + fieldName.replace('.', '\\.') + ':("[^"]+"|[^\\s)]+)', 'gi');
    var match;
    while ((match = regex.exec(String(rawQuery || ''))) !== null) {
      var value = unquoteFieldValue(match[1]);
      if (value && values.indexOf(value) === -1) values.push(value);
    }
    return values;
  }

  function visibleKeywordFromQuery(rawQuery) {
    if (!QUERY_FIELD_PREFIX.test(normalize(rawQuery))) return '';
    var titleValues = fieldValues(rawQuery, 'title');
    if (titleValues.length) return titleValues.join(' ');
    return '';
  }

  function searchQueryForKeyword(keyword) {
    var normalized = normalize(keyword);
    if (normalized.split(' ').filter(Boolean).length > 1 || isSingleKanaKeyword(normalized)) return normalized;
    var tag = categoryTagForKeyword(normalized) || normalized;
    return 'title:' + searchFieldValue(normalized) + ' OR tag:' + searchFieldValue(tag);
  }

  function ensureHiddenInput(form, name, value, ignoreInput) {
    var input = Array.prototype.slice.call(form.querySelectorAll('input[name="' + name + '"]')).find(function(candidate) {
      return candidate !== ignoreInput && candidate.type === 'hidden';
    });
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function visibleSearchInput(form) {
    return form.querySelector('input[name="q"]:not([type="hidden"])') ||
      form.querySelector('input[data-peta-original-name="q"]');
  }

  function hideVisibleSearchInputFromSubmit(input) {
    if (!input.dataset.petaOriginalName) {
      input.dataset.petaOriginalName = input.getAttribute('name') || 'q';
    }
    input.setAttribute('name', 'peta_display_q');
  }

  function restoreVisibleSearchInputName(input) {
    if (!input || !input.dataset.petaOriginalName) return;
    input.setAttribute('name', input.dataset.petaOriginalName);
    delete input.dataset.petaOriginalName;
  }

  function restoreVisibleSearchInputNames(root) {
    (root || document).querySelectorAll('input[data-peta-original-name]').forEach(restoreVisibleSearchInputName);
  }

  function normalizeSearchSubmit(event) {
    var form = event.target.closest('form[role="search"]');
    if (!form) return;

    var input = visibleSearchInput(form);
    if (!input) return;

    var rawKeyword = normalize(input.value);
    if (!rawKeyword || QUERY_FIELD_PREFIX.test(rawKeyword)) return;

    ensureHiddenInput(form, 'q', searchQueryForKeyword(rawKeyword), input);
    hideVisibleSearchInputFromSubmit(input);
    ensureHiddenInput(form, 'peta_keyword', rawKeyword);
    ensureHiddenInput(form, 'type', 'product');
    ensureHiddenInput(form, 'options[prefix]', 'last');
    if (!form.querySelector('input[name="sort_by"], select[name="sort_by"]')) {
      ensureHiddenInput(form, 'sort_by', 'most-relevant');
    }
    window.setTimeout(function() {
      restoreVisibleSearchInputNames(form);
    }, 3000);
  }

  function restoreVisibleSearchKeyword() {
    var params = new URLSearchParams(window.location.search);
    var visibleKeyword = params.get('peta_keyword') || visibleKeywordFromQuery(params.get('q'));
    if (!visibleKeyword) return;
    document.querySelectorAll('form[role="search"] input[name="q"], form[role="search"] input[data-peta-original-name="q"]').forEach(function(input) {
      input.value = visibleKeyword;
    });
  }

  function normalizeCurrentSearchUrl() {
    if (window.location.pathname !== '/search') return false;
    var params = new URLSearchParams(window.location.search);
    var rawKeyword = normalize(params.get('q'));
    if (!rawKeyword || QUERY_FIELD_PREFIX.test(rawKeyword)) return false;
    if (isSingleKanaKeyword(rawKeyword)) return false;

    var normalizedQuery = searchQueryForKeyword(rawKeyword);
    if (
      params.get('q') === normalizedQuery &&
      params.get('peta_keyword') === rawKeyword &&
      params.get('type') === 'product' &&
      params.get('options[prefix]') === 'last' &&
      !params.has('page')
    ) {
      return false;
    }

    params.set('q', normalizedQuery);
    params.set('peta_keyword', rawKeyword);
    params.set('type', 'product');
    params.delete('options');
    params.set('options[prefix]', 'last');
    if (!params.get('sort_by')) params.set('sort_by', 'most-relevant');
    params.delete('page');
    window.location.replace('/search?' + params.toString());
    return true;
  }

  function onReady() {
    if (normalizeCurrentSearchUrl()) return;
    restoreVisibleSearchKeyword();
  }

  document.addEventListener('submit', normalizeSearchSubmit, true);
  window.addEventListener('pageshow', function() {
    restoreVisibleSearchInputNames(document);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
